import { FC } from 'react';
import { TFunction } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import type { TopDestinationSlug } from 'src/common/components/LandingPageTopDestinations/types';
import LocationCard from './LocationCard';

import styles from './LandingPageTopDestinations.module.scss';

export type LandingPageTopDestinationsProps = {
  layoutBackgroundColor?: 'ivory' | 'pearl';
  slugs: TopDestinationSlug[];
  subtitle?: string;
  title: string;
  translationFunction?: TFunction;
  isCompact?: boolean;
};

const LandingPageTopDestinations: FC<LandingPageTopDestinationsProps> = ({
  layoutBackgroundColor = 'pearl',
  slugs,
  subtitle,
  title,
  translationFunction,
  isCompact,
}) => {
  const { isMobileNativeWebView } = useMobileNativeWebView();

  return (
    <div className={getClassNames(styles, 'layout', classNames({ isCompact }))}>
      <PitchPageLayout backgroundColor={layoutBackgroundColor}>
        <div className={getClassNames(styles, 'root', classNames({ isCompact }))} data-cwv="section--top-destinations">
          <CarouselProvider>
            <div className={styles.header}>
              <div className={styles.text}>
                <div className={styles.title}>
                  <Typography type="h3" size="display-5">
                    {title}
                  </Typography>
                </div>
                {subtitle && (
                  <div className={styles.subtitle}>
                    <Typography type="p" size="body-xl">
                      {subtitle}
                    </Typography>
                  </div>
                )}
              </div>
              <div className={styles.desktopButtons}>
                <CarouselButtons
                  variant="primary-dark"
                  spacing="together"
                />
              </div>
            </div>
            <Carousel>
              {slugs.map((slug) => (
                <LocationCard
                  key={slug.slug}
                  slug={slug}
                  translationFunction={translationFunction}
                />
              ))}
            </Carousel>
            {!isMobileNativeWebView && (
              <div className={styles.mobileButtons}>
                <CarouselButtons
                  variant="primary-dark"
                  spacing="together"
                />
              </div>
            )}
          </CarouselProvider>
        </div>
      </PitchPageLayout>
    </div>
  );
};

export default LandingPageTopDestinations;
